/* eslint-disable react-hooks/exhaustive-deps */
import { consumirServicioEncirptacion } from "api";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import Page from "components/Page";
import { urlGuardarContratantePymes, urlSeccionCargaContratante } from "constants/urls";
import { useNavbarContext } from "contexts/NavbarContext";
import React, { useCallback, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { PASOS_BREADCRUMBS } from "utils/constants";
import COLORS from "utils/constants/COLORS";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import Loading from "wrappers/Loading";
import DynamicForm from "../../components/DynamicForm";
import { BaseButton } from "./Componentes/entradas";
import { LF } from "./Constantes/general";
import useCustomToast from "hooks/useCustomToasts";
import ModalContratante from "components/ModalMex/ModalContratante";

export const LFCliente = ({ qParams: { idPoliza }, history }) => {
  const { addWarningToast, addSuccessToast } = useCustomToast();
  const [loading, setLoading] = useState(false);
  const [catalogo, setCatalogo] = useState({});
  const [validaciones, setValidaciones] = useState(null);
  useNavbarContext(PRODUCTOS.LINEAS_FINANCIERAS);
  const methods = useForm({ mode: "onChange" });

  const guardarInformacion = async (data, guardarDatos = true) => {
    setLoading(true);
    const Data = {
      prodCodigo: PRODUCTOS.LINEAS_FINANCIERAS,
      idPoliza,
      guardarDatos,
      datosContratanteAsegurado: data,
    };

    const res = await consumirServicioEncirptacion(urlGuardarContratantePymes, Data);

    console.log("RES: ", res);
    console.log("VALIDACIONES: ", validaciones);
    setLoading(false);
    await getData();

    return res;
  };

  const onSubmit = async (data) => {
    console.log("DATA: ", JSON.stringify(data));
    const res = await guardarInformacion(data, false);
    if (res?.transaccion === true) {
      history.push(`${LF.urls.vigencia}?idPoliza=${idPoliza}`);
    }
  };

  const getData = useCallback(async () => {
    setLoading(true);
    try {
      const Body = {
        pasoRevContratante: "obtenerContratante",
        pasoCatContratante: "catalogoContratante",
        formulario: "contratante",
        prodCodigo: LF.prodCodigoCore,
        polCodigo: idPoliza,
      };
      const res = await consumirServicioEncirptacion(urlSeccionCargaContratante, Body);
      console.log("RESPUESTA: ", res);
      console.log(res.data.catalogo);
      setCatalogo(res.data.catalogo);
      setValidaciones(res?.data?.catalogo?.validaciones || null);

      if (res?.data?.catalogo?.DatosContratanteAsegurado) {
        methods.reset(res?.data?.catalogo?.DatosContratanteAsegurado);
      }
    } catch (error) {
      setLoading(false);
    }
    setLoading(false);
  }, []);

  const regresar = () => {
    history.push(`${LF.urls.resumen}?idCotizacion=${catalogo?.idCotizacion || ""}`);
  };

  useEffect(() => {
    if (idPoliza) {
      getData();
    } else {
      history.push(`/`);
    }
  }, []);

  return (
    <Loading loading={loading}>
      {catalogo?.DatosContratanteAsegurado && (
                <ModalContratante catalogo={catalogo}/>
            )}  
      <div className='cr-content'>
        <Page>
          {/* <Breadcrumcomponent
                        {...pasosBreadCrumbHogar.breadCrumb}
                        showPaths={false}
                    /> */}

          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[PRODUCTOS.LINEAS_FINANCIERAS]
              .breadCrumbPasosCotizacion[4]}
            styleimg='height200px mr-3'
            pasos={PASOS_BREADCRUMBS[PRODUCTOS.LINEAS_FINANCIERAS]?.pasosCotizacion}
          />

          {/* <DevTool control={methods.control}/> */}
          <FormProvider {...methods}>
            <form
              id='form-preguntas'
              onSubmit={methods.handleSubmit(onSubmit)}
              className='row d-flex flex-wrap justify-content-center'>
              <div className='col-10 d-flex justify-content-center'>
                {validaciones && <DynamicForm {...validaciones} resources={catalogo} />}
              </div>
              <div className='col-12 d-flex flex-wrap justify-content-center'>
                <div className=' col-12 row justify-content-center'>
                  <div className='col-12 col-md-9 my-auto bg-white'>
                    <h6 className='ml-2 py-2 text-center' style={{ fontSize: "20px" }}>
                      Recuerda que al dar click en guardar, tu información quedará
                      almacenada y podrás cerrar la ventana en cualquier momento para
                      continuar después
                    </h6>
                  </div>
                </div>
                <div className='col-md-3 col-sm-12  mt-1'>
                  <BaseButton
                    onClick={() => {
                      regresar();
                    }}
                    type='button'
                    textColor='white'
                    bgColor={COLORS.primary}>
                    <i
                      className='pi pi-arrow-left'
                      style={{
                        position: "relative",
                        top: "1px",
                        fontSize: "1.4rem",
                      }}
                    />{" "}
                    Atrás
                  </BaseButton>
                </div>
                <div className='col-md-3 col-sm-12  mt-1'>
                  <BaseButton
                    type='button'
                    textColor='white'
                    bgColor={COLORS.primary}
                    onClick={async () => {
                      const res = await guardarInformacion(methods.getValues(), true);
                      if (res?.transaccion === true) {
                        addSuccessToast("Se ha guardado la información de forma correcta");
                      }
                    }}>
                    <i
                      className='pi pi-save'
                      style={{
                        position: "relative",
                        top: "2px",
                        fontSize: "1.4rem",
                      }}
                    />{" "}
                    GUARDAR
                  </BaseButton>
                </div>
                <div className='col-md-3 col-sm-12  mt-1'>
                  <BaseButton
                    textColor='white'
                    type='submit'
                    bgColor={COLORS.primary}
                  //onClick={onClickContinuar}
                  >
                    Continuar{" "}
                    <i
                      className='pi pi-arrow-right'
                      style={{
                        position: "relative",
                        top: "1px",
                        fontSize: "1.4rem",
                      }}
                    />
                  </BaseButton>
                </div>
              </div>
            </form>
          </FormProvider>
        </Page>
      </div>
    </Loading>
  );
};
